import { Vector3, BackSide, Euler } from "three";
import { EnvironmentSphereProps, AssetBackground360Props } from "../types";
import { useTexture } from "@react-three/drei";

const EnvironmentSphere = ({
  position = new Vector3(0, 0, 0),
  rotation = new Euler(0, 0, 0),
  scale = new Vector3(1, 1, -1),
  mapUrl,
  radius,
}: EnvironmentSphereProps) => {
  const materialTextureProps = useTexture({
    map: mapUrl,
  });
  const SPHERE_360_TESSELLATION = 64;

  return (
    <mesh position={position} scale={scale} rotation={rotation}>
      <sphereGeometry
        args={[radius, SPHERE_360_TESSELLATION, SPHERE_360_TESSELLATION]}
      />
      <meshBasicMaterial {...materialTextureProps} side={BackSide} />
    </mesh>
  );
};

export const Background360: React.FC<AssetBackground360Props> = ({
  asset,
  radius,
}) => {
  const cond = asset.url ? (
    <EnvironmentSphere mapUrl={asset.url} radius={radius} />
  ) : null;
  return cond;
};
